import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const InformationQualityService = {
  apply: async (payload) => axios.post(`${API_URL}/information_quality/apply`, payload).then(({data}) => data).catch((err) => { throw err }),
};

export default InformationQualityService;